import '../css/discordbutton.css'

const DiscSignIn = () => {
    const handleDiscordSignIn = () => {
        window.location.href = 'https://discord.com/oauth2/authorize?client_id=1248348018202378273&response_type=code&redirect_uri=http%3A%2F%2Floastats.info%3A8080%2Fdiscord%2Fauth&scope=identify+email'; // Example URL for Discord OAuth
    };

    return (
            <button onClick={handleDiscordSignIn} className="discord-button">
                Sign in with Discord
            </button>
    )
}

export default DiscSignIn